import { Report } from 'app/providers/storage-api/report.service';
import { TopMoverResult } from '../../../components/widget-top-movers/widget-top-movers.component';
import { AbstractChartReport } from '../chart-report-abstract/chart-report-abstract';

export class TopMoversChartReport extends AbstractChartReport {
  reportName = 'topMovers';
  reportHandler = (_dashboard, _widget, _response, _options) => {
    return {};
  };

  getFields() {
    return ['analyticItem', 'dateInterval'];
  }

  getAggregators() {
    return ['time'];
  }

  getGraphTypes() {
    return [];
  }

  isAnalyticItemSupported(analyticItem) {
    return analyticItem !== 'documents';
  }

  canSort() {
    return false;
  }

  public canSetChartMaximum(): boolean {
    return false;
  }

  async processTopMoverResponse(response, _filterQuery?: string): Promise<TopMoverResult[]> {
    const topMoversResults = [];
    const topMovers = response.items.root;

    for (const mover of Object.keys(topMovers)) {
      const currentMover = topMovers[mover];
      topMoversResults.push({
        featureName: currentMover.name,
        intervalPercentDiff: currentMover.intervalPercentDiff,
        longIntervalPercentDiff: currentMover.longIntervalPercentDiff,
        featureDocumentHits: currentMover.featureDocCount,
        intervalSentimentDiff: currentMover.intervalSentimentDiff,
        longIntervalSentimentDiff: currentMover.longIntervalSentimentDiff,
      });
    }

    return topMoversResults;
  }

  public async executeReportForTopMovers(
    filterQuery: string,
    dateOffset: number,
    selectedDate: string,
    minimumOccurrences: number
  ): Promise<TopMoverResult[]> {
    const params = await this.getParams();
    params['dateOffset'] = dateOffset;
    params['selectedDate'] = selectedDate;
    params['minimumOccurrences'] = minimumOccurrences;
    const response = await this.reportService.getReport(
      this.options.widgetDataSource.collectionName,
      this.options.widgetDataSource.groupId,
      this.reportName,
      params,
      'json',
      filterQuery,
      this.filterService.buildFilterStringClearPolarityFilters(
        this.options.filters,
        this.options.analyticItem
      ),
      undefined,
      this.options.projectId
    );

    this.lastDocumentCount = (<Report>response).totalHits;

    //Lesser of two evils for now to pass the filterQuery string in to processResponse for the wordcloud which
    //calls execute report again for the sentiment.  Getting the relevant information into the worldcloud chart when
    //it's making it's call would be a large overhaul.
    return await this.processTopMoverResponse(response, filterQuery);
  }
}
